import React from 'react'
import {Nav, NavItem} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {actionCreators} from '../../store/Account';
import {getUrls, PROFILE, ACCOUNT, BILLING} from './MenuConfig';
import NavDropdownMenu from './NavDropdownMenu';
import PropTypes from 'prop-types';
import withWindowDimensions from '../../hoc/withWindowDimensions';
import config from '../../config';

const SubNavigation = function (props) {

    
    let urls = [];
    let baseUrl = '';

    urls = getUrls(props.region).filter(u=>!u.hideOnBranding || !props.themeId);
    
    const isAccountRequired = urls && urls.length&& urls[0].account;
    
    let accountNumber = props.account
        ? props.account.value
        : '';
    baseUrl = `/${props.region}`;

    const getDropdownMenu = (isSmallScreen) => {
        
        
        const {dimensions} = props;

        
        let  disableMouseOver = (dimensions.width !== null  && dimensions.width <= 980);

       
        const onSelectHandler=(m)=>{
            
            if(props.onSelect){
                props.onSelect(m);
            }
        }

        if(props.region === PROFILE && props.themeId) {       
            return null;
        }
       
        return <NavDropdownMenu
            {...props} //passing props recieved from parent container without this it  will not close and possibly will have others problems! 
            baseUrl={isAccountRequired ? `${baseUrl}/${accountNumber}` : `${baseUrl}`}          
            urls={urls}        
            isSmallScreen={isSmallScreen} 
            disableMouseOver={disableMouseOver}   
            highlightActiveItem={props.highlightActiveItem}
            onSelect={onSelectHandler}
            />
    };

    const getPanelMenu = () => {
        
        const {dimensions} = props;
        
        if(dimensions.width !== null  && dimensions.width < config.MobileViewBreakpoint) return getDropdownMenu(true);
        return (
            
            <Nav className="view-minor-nav">
                {urls.map(u => (
                    <LinkContainer
                        key={u.id}
                        isActive={u.isActive}
                        to={(u.account) ? `${baseUrl}/${accountNumber}/${u.link}` : `${baseUrl}/${u.link}`}
                        exact={u.exact}>
                        <NavItem eventKey={u.id}>
                            {u.title}
                        </NavItem>
                    </LinkContainer>
                ))}
            </Nav>
        )
    }

    if (!props.account && isAccountRequired) 
        return null;
    return props.comp === 'menu'
        ? getDropdownMenu()
        : getPanelMenu();

}

SubNavigation.propTypes = {
    region: PropTypes
        .oneOf([PROFILE, ACCOUNT, BILLING])
        .isRequired
}

export default connect(
    (state) => ({ ...state.account, ...state.app }),
    (dispatch) => bindActionCreators(actionCreators, dispatch),
    null,
    { pure: false }
)(withWindowDimensions(SubNavigation));
